export const REQUEST_STATUS = {
  PENDING: "PENDING",
  APPROVED: "APPROVED",
  APPLIED: "APPLIED",
  REJECTED: "REJECTED",
  CANCELLED: "CANCELLED",
  UNKNOWN: "UNKNOWN"
} as const;

export const REQUEST_STATUS_BG = {
  [REQUEST_STATUS.PENDING]: "bg-[#FFF8E1]",
  [REQUEST_STATUS.APPLIED]: "bg-[#E3F2FD]",
  [REQUEST_STATUS.APPROVED]: "bg-[#E8F5E9]",
  [REQUEST_STATUS.REJECTED]: "bg-[#FFEBEE]",
  [REQUEST_STATUS.CANCELLED]: "bg-[#FFEBEE]",
  [REQUEST_STATUS.UNKNOWN]: "bg-[#FFEBEE]",
} as const;

export const REQUEST_STATUS_FG = {
  [REQUEST_STATUS.PENDING]: "bg-[#FFB300]",
  [REQUEST_STATUS.APPLIED]: "bg-[#1E88E5]",
  [REQUEST_STATUS.APPROVED]: "bg-[#43A047]",
  [REQUEST_STATUS.REJECTED]: "bg-[#E53935]",
  [REQUEST_STATUS.CANCELLED]: "bg-[#E53935]",
  [REQUEST_STATUS.UNKNOWN]: "bg-[#E53935]",
} as const;

export const REQUEST_STATUS_LABEL = {
  [REQUEST_STATUS.PENDING]: "Pendiente",
  [REQUEST_STATUS.APPLIED]: "Aplicada",
  [REQUEST_STATUS.APPROVED]: "Aprobada",
  [REQUEST_STATUS.REJECTED]: "Rechazada",
  [REQUEST_STATUS.CANCELLED]: "Cancelada",
  [REQUEST_STATUS.UNKNOWN]: "Desconocido",
} as const;
